import { NavLink, useNavigate } from "react-router-dom";
import { FileText, History, SlidersHorizontal, LogOut, Move } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "New Prescription", icon: FileText, end: true },
  { to: "/history", label: "History", icon: History },
  { to: "/alignment", label: "Print Alignment", icon: Move },
  { to: "/options", label: "Manage Dropdowns", icon: SlidersHorizontal },
];

export function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen">
      <aside className="no-print w-64 shrink-0 bg-[#0f172a] text-slate-200 flex flex-col">
        <div className="px-5 py-6 flex items-center border-b border-white/10">
          <img src="/lucid-logo-white.webp" alt="LUCID DENTAL" className="h-10 w-auto object-contain" data-testid="sidebar-logo" />
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-[#3aa0d6] text-white" : "text-slate-300 hover:bg-white/5"
                }`
              }
            >
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <div className="px-3 py-2 text-xs text-slate-400 truncate">{user?.name || user?.email}</div>
          <button
            onClick={() => { logout(); navigate("/login"); }}
            data-testid="logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-300 hover:bg-white/5"
          >
            <LogOut className="h-4 w-4" /> Log out
          </button>
        </div>
      </aside>
      <main className="flex-1 app-canvas overflow-x-auto">{children}</main>
    </div>
  );
}
